import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './HeaderNav.css';
import logo from './logo.svg';

class HeaderNav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <nav className="HeaderNav">
        <NavLink to="/first">First</NavLink>
        <NavLink to="/second">Second</NavLink>
        <NavLink exact to="/" className="HeaderNav-logo">
          <img src={ logo } alt="logo" />
        </NavLink>
        <NavLink to="/third">Third</NavLink>
        <NavLink to="/fourth">Fourth</NavLink>
      </nav>
    );
  }
}

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderNav/HeaderNav.js